<template>
  <div>
    <div class="bodyFake">
      <img
        class="img-responsive position-absolute"
        src="@/assets/img/mockups/pc-mockup.png"
        style="
          height: 445px;
          width: 100%;
          margin: 0;
          margin-top: -15px;
          margin-left: -5%;
        "
      />
      <div :style="`${headerStyle}`" class="pt-2 pb-4 mb-2">
        <b-row style="`${headerStyle}`" class="px-4">
          <b-col
            cols="2"
            class="d-flex align-items-center justify-content-start"
          >
            <b-img
              v-if="professional && profissional[0].foto_principal"
              :src="`${getImagesAddress}` + profissional[0].foto_principal"
              fluid
              width="40%"
            ></b-img>
          </b-col>
          <b-col cols="7" class=" d-flex align-items-center justify-content-center">
            <span :style="fontStyle" class="fs-14">Meus Trabalhos</span>
            <span :style="fontStyle" class="fs-14 ml-3 d-none d-sm-block">Sobre</span>
            <span :style="fontStyle" class="fs-14 ml-3 d-none d-sm-block">Contato </span>
          </b-col>
          <b-col cols="3" class="d-flex align-items-center justify-content-end">
            <b-button :style="`${primaryButtonStyle}`" size="sm" >
              <i class="fas fa-phone-alt mr-1" :style="`${iconStyle}`"></i>
              <span :style="fontStyle" class="smallWindow">Entre em contato</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    
      <div :style="`${backgroundStyle}`" class="pt-1 margin-body ">
        <div  style="height: 100px;" class="ml-3 mr-3">
          <b-img
            v-if="companyBanner !== null"
            :src="`${getImagesAddress}${companyBanner[0].image}`"
            class="img-fluid h-100 w-100"
          >
          </b-img>
          <b-skeleton v-else no-aspect height="90px" style="cursor: default;"></b-skeleton>
        </div>
        
        <b-row class="ml-2 mr-2">
          <b-col cols="12">
            <span :style="primaryStyle" class="font-weight-bold">Conheça meus trabalhos</span>
            <b-row>
              <b-col v-for="index in 4" :key="index">
                <b-skeleton-img no-aspect height="65px" style="cursor: default;"></b-skeleton-img>
              </b-col>
            </b-row>
          </b-col> 
  
          <b-col cols="12" class="mt-2">
            <span class="font-weight-bold" :style="primaryStyle">Sobre</span>
            <p :style="fontStyle" class="fs-12">Seu texto falando sobre a empresa</p>
          </b-col>
        </b-row>
      </div>

      <div :style="`${footerStyle}`" class="pt-2 pb-3">
        <b-row class="px-4">
          <b-col
            cols="3"
            class="d-flex align-items-center justify-content-start"
          >
            <b-img
              v-if="professional && profissional[0].foto_principal"
              :src="`${getImagesAddress}` + profissional[0].foto_principal"
              fluid
              width="40%"
            ></b-img>
          </b-col>
          <b-col cols="3" class="">
            <span :style="fontStyle" class="fs-12 d-none d-sm-block">
              <strong>MAPA DO SITE</strong>
            </span>
            <span :style="fontStyle" class="fs-12 d-none d-sm-block">Sobre</span>
          </b-col>
          <b-col cols="3" class="">
            <span :style="fontStyle" class="fs-12 d-none d-sm-block">
              <strong>LOCALIZAÇÃO</strong>
            </span>
            <span :style="fontStyle" class="fs-12 d-none d-sm-block">Seu endereço</span>
          </b-col>
          <b-col cols="3" class="">
            <span :style="fontStyle" class="fs-12 d-none d-sm-block">
              <strong>CONTATO</strong>
            </span>
            <span v-if="fields.whatsapp.url" :style="fontStyle" class="fs-12 d-none d-sm-block">
              <i class="fas fa-phone-alt mr-1" :style="`${iconStyle}`"></i>
              {{ fields.whatsapp.url }}
            </span>
            <span v-else :style="fontStyle" class="fs-12 d-none d-sm-block">
              <i class="fas fa-phone-alt mr-1" :style="`${iconStyle}`"></i>
              (XX) XXXXX-XXXX
            </span>
          </b-col>
          <b-col cols="12" class="mt-1">
            <div class="d-flex justify-content-between">
              <span :style="fontStyle" class="fs-12 d-none d-sm-block">
                Todos direitos reservados
              </span>
              <span>
                <i v-if="fields.instagram.url" class="fab fa-instagram mr-3" :style="`${iconStyle}`"></i>
                <i v-if="fields.facebook.url" class="fab fa-facebook mr-3" :style="`${iconStyle}`"></i>
                <i v-if="fields.whatsapp.url" class="fab fa-whatsapp mr-3" :style="`${iconStyle}`"></i>
                <i v-if="fields.twitter.url" class="fab fa-twitter mr-3" :style="`${iconStyle}`"></i>
                <i v-if="fields.youtube.url" class="fab fa-youtube mr-3" :style="`${iconStyle}`"></i>
                <i v-if="fields.tiktok.url" class="fab fa-tiktok mr-3" :style="`${iconStyle}`"></i>
              </span>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'FakeWebProfessional',
  props: {
    primaryColor: {
      type: String,
      required: false,
      default: 'white',
    },
    headerMenuColor: {
      type: String,
      required: false,
      default: 'white',
    },
    footerColor: {
      type: String,
      required: false,
      default: 'white',
    },
    fontColor: {
      type: String,
      required: false,
      default: 'black',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    atualizar: {
      type: Boolean,
      required: false
    },
    about: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      profissional: (state) => state.profissional,
    }),

    iconStyle() {
      return `color: ${this.iconColor};`;
    },
    fontStyle() {
      return `color: ${this.fontColor};`;
    },
    primaryStyle() {
      return `color: ${this.primaryColor};`;
    },
    primaryButtonStyle() {
      return `background-color: ${this.primaryColor};`;
    },
    backgroundStyle() {
      return `background-color: ${this.backgroundColor};`;
    },
    headerStyle() {
      return `background-color: ${this.headerMenuColor};`;
    },
    footerStyle() {
      return `background-color: ${this.footerColor};`;
    },
  },
  
  data() {
    return {
      companyBanner: null,
      fields: {
        instagram: {
          id: 0,
          url: '',
          type: 'instagram',
        },
        facebook: {
          id: 0,
          url: '',
          type: 'facebook',
        },
        whatsapp: {
          id: 0,
          url: '',
          type: 'whatsapp',
        },
        twitter: {
          id: 0,
          url: '',
          type: 'twitter',
        },
        youtube: {
          id: 0,
          url: '',
          type: 'youtube',
        },
        tiktok: {
          id: 0,
          url: '',
          type: 'tiktok',
        },
      }
    };
  },
  mounted() {
    this.list();
    this.getMedias();
  },
  methods: {
    ...mapActions('professional', ['getSocialMedias', 'listBanner']),
    
    list() {
      this.loading = true;
      
      this.listBanner(this.dadosUsuario.informacoes.id)
      .then((response) => {
        
        this.companyBanner = response.data.data.length > 0 ?  response.data.data : null;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os banners',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getMedias() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.getSocialMedias(this.dadosUsuario.informacoes.id)
        .then((response) => {
          if (!response.data.data || !response.data.data.length) return;
          response.data.data.forEach((socialMedia) => {
            Object.keys(this.fields).forEach((key) => {
              if (this.fields[key].type !== socialMedia.type) return;
 
              this.fields[key] = {
                id: socialMedia.id,
                url: socialMedia.url,
                type: socialMedia.type,
              };
            });
          });
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as redes sociais',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  }
};
</script>

<style scoped>

.margin-body {
  margin-top: -23px;
}

@media (max-width: 768px) {
  .bodyFake {
    width:96%;
  } 
  .smallWindow {
    display: none;
  }
}

@media (min-width: 769px) {
  .bodyFake {
    width:94%;
  } 
}
</style>